import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { loadConfig } from './config/runtime-config'
import { analyticsService } from './services/analyticsService'

console.log('🚀 [main.tsx] Application starting...');

// Start native initialization immediately so splash timing does not wait for
// runtime configuration or React rendering.
try {
  const isNative = typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform?.();
    const disableCap = (import.meta as any)?.env?.VITE_DISABLE_CAPACITOR === '1' || (typeof process !== 'undefined' && (process as any).env?.VITE_DISABLE_CAPACITOR === '1');
    if (isNative && !disableCap) {
      // Start attribution/user-property sync before runtime config and React.
      void analyticsService.setStoreProvider();
      void analyticsService.setAdtraceCampaign();
      import(/* @vite-ignore */ './utils/capacitor').then((m) => {
        void m.CapacitorUtils.initializeApp();
      }).catch(() => {});
  }
} catch {}

// Load runtime config first, then render app
loadConfig().then(() => {
  console.log('✅ [main.tsx] Runtime config loaded');

  // Complete native-only startup work after runtime configuration is loaded.
  try {
    const isNative = typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform?.();
    const disableCap = (import.meta as any)?.env?.VITE_DISABLE_CAPACITOR === '1' || (typeof process !== 'undefined' && (process as any).env?.VITE_DISABLE_CAPACITOR === '1');
    if (isNative && !disableCap) {
      void analyticsService.syncSubscriptionStatus();
    }
  } catch {}

  const rootElement = document.getElementById('root');
  console.log('🎯 [main.tsx] Root element found:', !!rootElement);

  if (!rootElement) {
    console.error('❌ [main.tsx] Root element not found!');
  }

  createRoot(rootElement!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )

  console.log('✅ [main.tsx] React app rendered');
});
